{
  "activeMiners": "Aktif Madenciler",
  "approvedRewards": "Onaylanan Ödüller",
  "assetOverview": "Hesap ve Varlıklar",
  "buyExalt": "EXALT Satın Al",
  "community": "Topluluk",
  "dashboardSubtitle": "Profesyonel Dijital Varlık Borsası",
  "dashboardTitle": "Kontrol Paneli",
  "displayCurrency": "Görüntüleme para birimi",
  "earn": "Kazan",
  "estimatedExchangeWalletValue": "Tahmini Borsa Cüzdan Değeri",
  "exchangeActivity": "Borsa Etkinliği",
  "hideBalances": "Bakiyeleri gizle",
  "leaderboard": "Liderlik Tablosu",
  "live": "CANLI",
  "liveMarketBoard": "● Canlı Piyasa Panosu",
  "loading": "Yükleniyor...",
  "marketCap": "Piyasa Değeri",
  "marketStatus": "Piyasa Durumu",
  "miningPool": "Madencilik Havuzu",
  "noActivityYet": "Henüz Etkinlik Yok",
  "notifications": "Bildirimler",
  "pendingRewards": "Bekleyen Ödüller",
  "portfolioValue": "Portföy Değeri",
  "quickActions": "Hızlı İşlemler",
  "readyTradingWithdrawal": "İşlem veya Para Çekmeye Hazır",
  "recentActivity": "Son Etkinlik",
  "recentOrders": "Son Emirler",
  "refresh": "Yenile",
  "refreshDashboard": "Kontrol Panelini Yenile",
  "security": "Güvenlik ve Doğrulama",
  "showBalances": "Bakiyeleri göster",
  "submitListing": "Listeleme Başvurusu Gönder",
  "topGainer": "En Çok Yükselen",
  "topLoser": "En Çok Düşen",
  "totalPortfolioValue": "Toplam Portföy Değeri",
  "trendingCoins": "Trend Coinler",
  "unavailable": "Kullanılamıyor",
  "viewMarketBoard": "Piyasa Panosunu Görüntüle",
  "waitingAdminApproval": "Yönetici Onayı Bekleniyor",
  "walletStatus": "Cüzdan Durumu"
}